import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { incidentsService } from "../services/incidents.service";
import { IOption } from "Dashboard/domain/IOption";

const IncidentTypeSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const data = await incidentsService.getAllIncidentTypes();
      const op = data.map((incident) => {
        return {
          label: incident.name,
          value: incident.incidentTypeId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      if (props.options) {
        setOptions(props.options);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options]);

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        setValueFunction(values[0]);
      } else setValueFunction(undefined);
    }
  }, [options, props.defaultValue]);

  const getValue = () => {
    if (value) {
      return value;
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  const createOption = async (name: string): Promise<IOption> => {
    try {
      const incident = await incidentsService.createIncidentType(name);
      return {
        label: incident.name,
        value: incident.incidentTypeId,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      props.setIncidentTypeOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      isClearable
      menuPosition="fixed"
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={getValue()}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      formatCreateLabel={formatCreate}
      placeholder={props.placeholder ? props.placeholder : ""}
      isLoading={isLoading}
      isDisabled={isLoading || (props.disabled === true)}
      {...{ error: props.error }}
    />
  );
});

export default IncidentTypeSelect;
